import { IComponentTemplate } from 'elements/types';

export const mapQuantityChange = (quantity: number, part: IComponentTemplate) => ({
  elementComponentTemplateAssociation: {
    id: part.elementComponentTemplateAssociationId,
    quantity,
  },
});

export const mapUomChange = (uom: string, part: IComponentTemplate) => ({
  componentTemplate: {
    id: part.id,
    uom,
  },
});
